module.exports = __webpack_public_path__ + "static/img/0004.68e379f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt2/0004.png
// module id = RlBD
// module chunks = 1